// extracted by mini-css-extract-plugin
export var background = "styles-module--background--c2b8d";
export var blog = "styles-module--blog--461ba";
export var container = "styles-module--container--9d3b2";
export var content = "styles-module--content--a000c";
export var image = "styles-module--image--e0f86";
export var imageMobile = "styles-module--imageMobile--06bb6";
export var text = "styles-module--text--7f709";
export var title = "styles-module--title--98c4d";